<template>

	<div class="modal">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title">{{ title }}<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<div :class="{container:true,wistia:type==='wistia'}">
						<iframe v-if="type==='youtube'" :src="embedUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
						<iframe v-if="type==='cloudflare'" :src="embedUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
						<iframe v-if="type==='wistia'" :src="'https://fast.wistia.net/embed/iframe/'+videoId+'?seo=true&videoFoam=true&autoPlay='+(autoPlay?'true':'')" :title="title" :allow="allow" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="100%" height="100%"></iframe>
					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { mapState } from 'vuex'
import ApiService from './../services/api.service'
export default {
	name: 'VideoPlayer',
	props: {
		title: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'youtube'
		},
		videoId: {
			type: String,
			default: 'youtube'
		},
		playlist: {
			type: Boolean,
			default: false
		},
		customPlaylist: {
			type: Array,
			default: function () { return [] }
		},
		autoPlay: {
			type: Boolean,
			default: true
		}
	},
	data() {

		return {
			allows: ['fullscreen']
		}

	},

	computed: {

		...mapState('general',['videos']),

		allow () {

			return this.allows.join('; ');

		},

		embedUrl () {

			switch ( this.type ) {

				case "youtube" :

					if ( this.customPlaylist.length > 0 ) {

						return 'https://www.youtube.com/embed/' + this.videoId + '?modestbranding=1&playlist=' + this.customPlaylist.join(',');

					}

					return ( this.playlist ? 'https://www.youtube.com/embed/videoseries?modestbranding=1&list=' : 'https://www.youtube.com/embed/' ) + this.videoId;

				break;

				case "cloudflare" :

					return 'https://customer-v1tllgjsnulcrl1n.cloudflarestream.com/' + this.videoId + '/iframe?autoplay=true&poster=https%3A%2F%2Fcustomer-v1tllgjsnulcrl1n.cloudflarestream.com%2F' + this.videoId + '%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600';

			}

		}

	},

	methods: {

		close () {

			this.$emit('close');

		},
		logPlay () {

			let v = this.videos.find( vid => vid.videoId === this.videoId );

			if ( v && !!v.slug ) {

				ApiService.put( 'users/video-view/' + v.slug )
				.then( function( info ) {}.bind(this))
				.catch( function(err) {}.bind(this));

			}

		}
		
	},
	mounted() {

		if ( this.autoPlay ) {
			
			this.$el.querySelector('iframe').setAttribute('autoplay','');
			this.allows.push('autoplay');

		}

		if ( this.type === 'wistia' ) {

			let wistiaScript = document.createElement('script');
			wistiaScript.setAttribute('src', 'https://fast.wistia.net/assets/external/E-v1.js');
			document.body.appendChild(wistiaScript);

		}

		this.logPlay ();

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';

.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
  &.wistia {
	//padding-top: 53.13%;
  }
  iframe {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	border: none;
  }
}

</style>